import React from 'react';
var ERROR_STYLE = 'text-xs text-white font-body bg-error rounded absolute top-100 right-0 mt-1 whitespace-no-wrap px-1 z-10';
export var Error = function (_a) {
    var children = _a.children;
    return (React.createElement("span", { className: ERROR_STYLE }, children));
};
